// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Campus_imageWrapper__xduZJ","scrollContainer":"Campus_scrollContainer__qiapo","scrollLoop":"Campus_scrollLoop__xA9s5"};